"use client";

import { ChevronRight } from "@/components/icons/Chevron";
import { Link } from "@/i18n/Link";
import { trackContentClick } from "@/lib/analytics/trackContentClick";
import { sbLink } from "@/lib/storyblok/link";
import type { BlokPdpContentCard } from "@/storyblok";
import type { BlokProps } from "@frend-digital/storyblok";
import { clsx } from "@frend-digital/ui";
import type { StoryblokMultilink } from "storyblok";
import { AssetBlok, sizes } from "../Asset";
import BlokWrap from "../BlokWrap";
import styles from "./PdpContentCard.module.css";

export const PdpContentCardBlok = ({
	blok,
	className,
}: BlokProps<BlokPdpContentCard> & { className?: string }) => {
	const { title, media, preamble, link, linkText } = blok;
	const linkUrl = sbLink(link as StoryblokMultilink);

	return (
		<BlokWrap editable={blok} asChild>
			<div className={clsx(className)}>
				<article className={styles.content}>
					<div className={styles.imageContainer}>
						{media && <AssetBlok source={media} sizes={sizes(83, undefined, 25)} />}
					</div>
					<div className={styles.info}>
						<h3 className={styles.title}>{title}</h3>
						<p className={styles.text}>{preamble}</p>
					</div>
					{linkUrl && (
						<Link
							href={linkUrl.href}
							className={styles.link}
							{...(linkUrl.external && { target: linkUrl.target, rel: "noopener noreferrer" })}
							onClick={() =>
								trackContentClick({
									contentType: blok.component,
									itemId: blok._uid,
									href: linkUrl.href,
									label: linkText,
								})
							}
						>
							{linkText && (
								<>
									<span>{linkText}</span>
									<span className={styles.icon}>
										<ChevronRight />
									</span>
								</>
							)}
						</Link>
					)}
				</article>
			</div>
		</BlokWrap>
	);
};
